import mixpanel from 'mixpanel-browser';

const mp_session_config = {
  //thirty minutes in milliseconds - as defined in mixpanel dashboard
  timeout: 1800000,

  get_Session_id: function() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4()+s4()+'-'+s4()+'-'+s4()+'-'+s4()+'-'+s4()+s4()+s4();
  },

  set_Session_id: function() {
    mixpanel.register({
      "session ID": mp_session_config.get_Session_id()
    });
  },

  check_Session_id: function() {
    if (!mixpanel.get_property("last event time")) {
      mp_session_config.set_Session_id();
    }

    if (!mixpanel.get_property("session ID")) {
      mp_session_config.set_Session_id();
    }

    if (Date.now() - mixpanel.get_property("last event time") > mp_session_config.timeout) {
      mp_session_config.set_Session_id();
    }
  }
}


class MixpanelService {
  constructor() {}

  init(token, env) {
    if (mixpanel) {
      mixpanel.init(token, {loaded:this.onMixpanelLoaded.bind(this, env)});
    }
  }

  onMixpanelLoaded(env, mixpanelInstance){
    mp_session_config.check_Session_id();

    //Override the mixpanel track method so we will be able to check the sessionID.
    const originalTrack = mixpanelInstance.track;
    mixpanelInstance.track = function() {

      mp_session_config.check_Session_id();
      mixpanelInstance.register({
        "last event time": Date.now(),
        "environment": env,
        "platform": 'web',
      });
      originalTrack.apply(mixpanelInstance, arguments);
    };
  }

  track(event, properties = {}, callback = null) {
    if (mixpanel) {
      if(window.sunbitEnv !== 'oregon-prod'){
        this.devTrack(event, properties);
      }
      else {
        mixpanel.track(event, properties, callback);
      }
    }
  }

   devTrack(eventName , eventData, ignored =false) {
     console.log(`%c mixPanel ${ignored ? '!!!IGNORED!!!' : ''} dev env log:`, 'color: green; font-wight: bold; font-size: 1.3em;');
     console.log(`Event Name: ${eventName}, properties:`, {
       ...eventData,
     });
   }

  identify(accountId) {
    if (mixpanel) {
      mixpanel.identify(accountId);
      mixpanel.register({customerId: accountId}, new Date(Date.now()).toDateString());
    }
  }

  reset(){
    if(mixpanel){
      mixpanel.reset();
    }
  }
}

export default new MixpanelService();



// WEBPACK FOOTER //
// ./src/services/mixpanel.js